import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
} from "@angular/core";
import { environment } from "../../../environments/environment";
import { MzBaseModal } from "ng2-materialize";
import { Project } from "../../interfaces/project";
import { Utils } from "../../utils/utils";
import { Questionnaire } from "../../interfaces/questionnaire";
import { DeleteItemConfirmationDialogComponent } from "../delete-item-confirmation-dialog/delete-item-confirmation-dialog.component";

@Component({
  selector: "app-create-questionnaire-dialog",
  templateUrl: "./create-questionnaire-dialog.component.html",
  styleUrls: ["./create-questionnaire-dialog.component.scss"],
})
export class CreateQuestionnaireDialogComponent
  extends MzBaseModal
  implements OnInit {
  readonly env: any = environment;
  readonly utils: any = Utils;

  error: string;

  @Input() project: Project;
  @Input() questionnaires: Questionnaire[];

  @Output()
  createQuestionnaireClicked: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild("ConfirmCreateModal")
  ConfirmCreateModal: DeleteItemConfirmationDialogComponent;

  newQuestionnaire: Questionnaire;
  canCreate: boolean;

  constructor() {
    super();
  }

  ngAfterViewInit() {}

  ngOnInit() {
    this.newQuestionnaire = { recipients: [] } as Questionnaire;
  }

  async validateName(newValue) {
    let nameNotEmpty = newValue && newValue.trim() !== "";
    let nameAlreadyExists =
      this.questionnaires &&
      this.questionnaires.filter(
        (x) =>
          x.name.localeCompare(newValue, undefined, {
            sensitivity: "base",
            ignorePunctuation: true,
            usage: "search",
          }) === 0
      ).length > 0;
    let recipientNotEmpty =
      this.newQuestionnaire.recipients[0] &&
      this.newQuestionnaire.recipients[0].trim() !== "";
    let textNotEmpty =
      this.newQuestionnaire.recipients[1] &&
      this.newQuestionnaire.recipients[1].trim() !== "";
    this.canCreate =
      nameNotEmpty && recipientNotEmpty && !nameAlreadyExists && textNotEmpty;
    this.error = nameAlreadyExists
      ? "Ein Fragebogen mit dieser Bezeichnung existiert bereits."
      : null;
  }

  async validateRecipient(newRecipient) {
    let nameNotEmpty =
      this.newQuestionnaire.name && this.newQuestionnaire.name.trim() !== "";
    let nameAlreadyExists =
      this.questionnaires &&
      this.questionnaires.filter(
        (x) =>
          x.name.localeCompare(this.newQuestionnaire.name, undefined, {
            sensitivity: "base",
            ignorePunctuation: true,
            usage: "search",
          }) === 0
      ).length > 0;
    let recipientNotEmpty = newRecipient && newRecipient.trim() !== "";
    let textNotEmpty =
      this.newQuestionnaire.recipients[1] &&
      this.newQuestionnaire.recipients[1].trim() !== "";
    this.canCreate =
      nameNotEmpty && recipientNotEmpty && !nameAlreadyExists && textNotEmpty;
    this.error = nameAlreadyExists
      ? "Ein Fragebogen mit dieser Bezeichnung existiert bereits."
      : null;
  }

  async validateText(newText) {
    let nameNotEmpty =
      this.newQuestionnaire.name && this.newQuestionnaire.name.trim() !== "";
    let nameAlreadyExists =
      this.questionnaires &&
      this.questionnaires.filter(
        (x) =>
          x.name.localeCompare(this.newQuestionnaire.name, undefined, {
            sensitivity: "base",
            ignorePunctuation: true,
            usage: "search",
          }) === 0
      ).length > 0;
    let recipientNotEmpty =
      this.newQuestionnaire.recipients[0] &&
      this.newQuestionnaire.recipients[0].trim() !== "";
    let textNotEmpty = newText && newText.trim() !== "";
    this.canCreate =
      nameNotEmpty && recipientNotEmpty && !nameAlreadyExists && textNotEmpty;
    this.error = nameAlreadyExists
      ? "Ein Fragebogen mit dieser Bezeichnung existiert bereits."
      : null;
  }

  /**
   * creates new Item
   */
  async createQuestionnaire() {
    if (this.canCreate) {
      this.modalComponent.close();
      let confirm = await this.ConfirmCreateModal.getResultAsync(); //fragt nochmal ab, ob fragebogen verschickt werden soll.
      if (confirm) {
        this.newQuestionnaire.projectId = this.project._id;
        this.createQuestionnaireClicked.emit(this.newQuestionnaire);
        this.newQuestionnaire = { recipients: [] } as Questionnaire;
        this.canCreate = false;
      } else {
        this.modalComponent.open();
      }
    }
  }

  /**
   * resets newItem object and closes modal
   * @param modal
   */
  closeSprintModal() {
    this.newQuestionnaire = { recipients: [] } as Questionnaire;
    this.canCreate = false;
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/create-questionnaire-dialog/create-questionnaire-dialog.component.ts